<template>
    <TransitionGroup
        tag="ol"
        name="toast"
        class="fixed bottom-28 right-8 list-none p-0 m-0 w-[356px]"
        :style="listStyle"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
    >
        <ToastItem
            v-for="(toast, index) in toastState.toasts"
            :key="toast.id"
            :toast="toast"
            :index="index"
            :toasts="toastState.toasts"
            :expanded="toastState.expanded"
            :visible-toasts="visibleToasts"
            :gap="gap"
            @update-height="updateHeight"
            @close="onToastClose"
        />
    </TransitionGroup>
</template>

<script setup>
import { computed } from "vue";
import { getState, removeToast, updateHeight, setExpanded } from "./toast-state";
import ToastItem from "./ToastItem.vue";

const toastState = getState();
const visibleToasts = 3;
const gap = 14;
const zIndex = 99999999;

const frontToastHeight = computed(() => {
    const toasts = toastState.toasts;
    if (toasts.length === 0) return 0;
    return toasts[toasts.length - 1].height || 0;
});

const listStyle = computed(() => {
    const toasts = toastState.toasts;
    const count = toasts.length;

    if (count === 0) {
        return { height: "0px", zIndex: zIndex, pointerEvents: "none" };
    }

    let height;
    if (toastState.expanded) {
        height = toasts.reduce((sum, t) => sum + (t.height || 0), 0)
            + Math.max(0, count - 1) * gap;
    } else {
        const peekCount = Math.min(count - 1, visibleToasts - 1);
        height = frontToastHeight.value + peekCount * 8;
    }

    return {
        height: height + "px",
        zIndex: zIndex,
        transition: "height 300ms ease",
    };
});

function onMouseEnter() {
    if (toastState.toasts.length > 1) {
        setExpanded(true);
    }
}

function onMouseLeave() {
    setExpanded(false);
}

function onToastClose(id) {
    const toast = toastState.toasts.find((t) => t.id === id);
    if (toast && toast.onClose) {
        toast.onClose();
    }
    removeToast(id);
}
</script>

<style>
.toast-enter-from,
.toast-leave-to {
    opacity: 0 !important;
    transform: translateY(20px) scale(1) !important;
}

.toast-enter-active,
.toast-leave-active {
    transition: all 300ms ease !important;
}
</style>
